import { useContext } from 'react';

import { InputContext } from 'src/contexts/input.context';
import { ParserContext } from 'src/contexts/parser.context';
import { UseIcon } from 'src/components/UseIcon';
import { P2 } from 'src/components/Typography';
import clsx from 'clsx';

export function Email() {
  const { onClick, value } = useContext(InputContext);

  const spreadsheetContext = useContext(ParserContext);

  const valueProp = value ?? spreadsheetContext.value;

  if (!valueProp) return <div className='w-100p' onClick={onClick} />;

  return (
    <div className={clsx(spreadsheetContext.classNames?.container, 'row items-p8 a-center w-100p o-hidden')}>
      <P2
        className={clsx('t-ellipsis', spreadsheetContext.script?.isEditable ? 'c-pointer' : 'c-default')}
        title={valueProp}
        onClick={onClick ?? spreadsheetContext.onClick}
      >
        {valueProp}
      </P2>
      <a href={`mailto:${valueProp}`} target='_blank' rel='noopener noreferrer'>
        <UseIcon className='default-icon' iconId='envelope' />
      </a>
    </div>
  );
}
